export const normalizeYearText = (yearText) => {
  if (!yearText) return "";
  let normalizedYear = yearText;
  if (yearText.length === 2) {
    normalizedYear = `20${yearText}`;
  }
  if (normalizedYear.length === 4) {
    if (normalizedYear === "0000") {
      normalizedYear = "2000";
    }
    if (/^00\d{2}$/.test(normalizedYear)) {
      normalizedYear = `20${normalizedYear.slice(2)}`;
    }
    return normalizedYear;
  }
  return normalizedYear;
};
export const splitFechaFromDigits = (digits) => {
  if (!digits) {
    return { day: "", month: "", year: "" };
  }
  let cursor = 0;
  let day = "";
  let month = "";
  if (digits.length >= 2) {
    const dayCandidate = Number(digits.slice(0, 2));
    if (dayCandidate >= 1 && dayCandidate <= 31) {
      day = digits.slice(0, 2);
      cursor = 2;
    } else {
      day = `0${digits[0]}`;
      cursor = 1;
    }
  } else {
    day = digits;
    cursor = 1;
  }
  const remainingAfterDay = digits.slice(cursor);
  if (!remainingAfterDay) {
    return { day, month: "", year: "" };
  }
  if (remainingAfterDay.length >= 2) {
    const monthCandidate = Number(remainingAfterDay.slice(0, 2));
    if (monthCandidate >= 1 && monthCandidate <= 12) {
      month = remainingAfterDay.slice(0, 2);
      cursor += 2;
    } else {
      month = `0${remainingAfterDay[0]}`;
      cursor += 1;
    }
  } else {
    month = remainingAfterDay;
    cursor += 1;
  }
  const year = normalizeYearText(digits.slice(cursor, cursor + 4));
  return { day, month, year };
};
export const buildFechaFromDigits = (digits) => {
  const cleanedDigits = digits.replace(/\D/g, "").slice(0, 8);
  const { day, month, year } = splitFechaFromDigits(cleanedDigits);
  if (!day) return "";
  if (!month) return day;
  if (!year) return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/`;
  return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
};
export const normalizeFechaInput = (value) => {
  return buildFechaFromDigits(value);
};
export const parseFechaNacimiento = (value) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/.exec(value);
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(normalizeYearText(match[3]));
  if (day < 1 || day > 31 || month < 1 || month > 12) {
    return null;
  }
  const date = new Date(year, month - 1, day);
  const isSameDate =
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day;
  return isSameDate ? date : null;
};
export const toIsoDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};
export const toDisplayDate = (date) => {
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const y = date.getFullYear();
  return `${d}/${m}/${y}`;
};
export const isoToDisplayDate = (isoDate) => {
  if (!isoDate) return "";
  const [year = "", month = "", day = ""] = isoDate.split("-");
  if (!year || !month || !day) return "";
  return `${day}/${month}/${year}`;
};
export const getAllowedBirthDateRange = () => {
  const today = new Date();
  const maxDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  return { maxDate };
};
export const isBirthDateInAllowedRange = (birthDate) => {
  const { maxDate } = getAllowedBirthDateRange();
  return birthDate <= maxDate;
};
export const toReadOnlyValue = (value) => {
  const normalized = String(value ?? "").trim();
  return normalized || "-";
};
